import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const getTickers = () => api.get("/tickers").then((r) => r.data);
export const getChain = (symbol) =>
  api.get(`/tickers/${symbol}/chain`).then((r) => r.data);
export const listPositions = (strategy) =>
  api.get("/positions", strategy ? { params: { strategy } } : undefined).then((r) => r.data);
export const createPosition = (body) =>
  api.post("/positions", body).then((r) => r.data);
export const deletePosition = (id) =>
  api.delete(`/positions/${id}`).then((r) => r.data);
export const analyzeRoll = (body) =>
  api.post("/roll/analyze", body).then((r) => r.data);
export const getHeatmap = (position_id) =>
  api.post("/roll/heatmap", { position_id }).then((r) => r.data);
export const getQuote = (symbol) => api.get(`/tickers/${symbol}/quote`).then((r) => r.data);
export const getWatchlist = () => api.get("/watchlist").then((r) => r.data);
export const addToWatchlist = (symbol) =>
  api.post("/watchlist", { symbol }).then((r) => r.data);
export const removeFromWatchlist = (symbol) =>
  api.delete(`/watchlist/${symbol}`).then((r) => r.data);
export const executeRoll = (positionId, body) =>
  api.post(`/positions/${positionId}/roll`, body).then((r) => r.data);
export const getHistory = (strategy) =>
  api.get("/history", strategy ? { params: { strategy } } : undefined).then((r) => r.data);
export const deleteHistoryEvent = (eventId) => api.delete(`/history/${eventId}`).then((r) => r.data);

// Trading (Tradier)
export const getTradingConnection = () => api.get("/trading/connection").then((r) => r.data);
export const connectTradier = (body) => api.post("/trading/connect", body).then((r) => r.data);
export const disconnectTradier = () => api.delete("/trading/connect").then((r) => r.data);
export const setTradeMode = (mode) => api.post("/trading/mode", { trade_mode: mode }).then((r) => r.data);
export const getTradingOrders = () => api.get("/trading/orders").then((r) => r.data);
export const adminToggleTrading = (userId, enabled) =>
  api.post(`/trading/admin/${userId}`, { enabled }).then((r) => r.data);
export const orderSellToOpen = (body) => api.post("/trading/orders/sell-to-open", body).then((r) => r.data);
export const orderBuyToClose = (body) => api.post("/trading/orders/buy-to-close", body).then((r) => r.data);
export const orderRoll = (body) => api.post("/trading/orders/roll", body).then((r) => r.data);
export const orderStatus = (orderId) => api.get(`/trading/orders/${orderId}/status`).then((r) => r.data);
export const cancelOrder = (orderId) => api.delete(`/trading/orders/${orderId}`).then((r) => r.data);
export const importPreview = () => api.get("/trading/import/preview").then((r) => r.data);
export const importCommit = (occ_symbols) =>
  api.post("/trading/import", { occ_symbols }).then((r) => r.data);

// Backtest (replay) API
export const btMeta = () => api.get("/backtest/meta").then((r) => r.data);
export const btListSessions = () => api.get("/backtest/sessions").then((r) => r.data);
export const btCreateSession = (body) => api.post("/backtest/sessions", body).then((r) => r.data);
export const btGetSession = (id) => api.get(`/backtest/sessions/${id}`).then((r) => r.data);
export const btDeleteSession = (id) => api.delete(`/backtest/sessions/${id}`).then((r) => r.data);
export const btStep = (id, body) => api.post(`/backtest/sessions/${id}/step`, body).then((r) => r.data);
export const btChain = (id, symbol) => api.get(`/backtest/sessions/${id}/chain/${symbol}`).then((r) => r.data);
export const btHeatmap = (id, position_id) =>
  api.post(`/backtest/sessions/${id}/heatmap`, { position_id }).then((r) => r.data);
export const btAnalyze = (id, body) => api.post(`/backtest/sessions/${id}/analyze`, body).then((r) => r.data);
export const btOpenPosition = (id, body) => api.post(`/backtest/sessions/${id}/positions`, body).then((r) => r.data);
export const btRoll = (id, pid, body) =>
  api.post(`/backtest/sessions/${id}/positions/${pid}/roll`, body).then((r) => r.data);
export const btClose = (id, pid) => api.post(`/backtest/sessions/${id}/positions/${pid}/close`).then((r) => r.data);
